import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";
import { MatIconRegistry } from '@angular/material/icon';
import { UserApiService } from 'src/app/user-api.service';
const paiement = "../assets/img/Pictos_Appli/Orange/SVG/Picto_Visa_orange.svg";

@Component({
  selector: 'app-user-eco',
  templateUrl: './user-eco.component.html',
  styleUrls: ['./user-eco.component.scss']
})
export class UserEcoComponent implements OnInit {

  constructor( private userApiService: UserApiService, public router: Router, private matIconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer)
  { this.matIconRegistry.addSvgIcon("paiement", this.domSanitizer.bypassSecurityTrustResourceUrl(paiement))}

  FactureUser = []
  userPaieFormu = null 
  paymode : string = null
  payment : boolean 
  card : any
 

  ngOnInit() {
      this.SubscribeUserDetailPayment()
      this.SubscribePayment()
  }


 startdate = new Date('2011-01-01T00:00:00Z');
 enddate = new Date()
  SubscribeFactureUser(){
    this.userApiService.getFactureUser(this.startdate, this.enddate).subscribe( x => {this.FactureUser=x.data.list} )
  }


  SubscribePayment(){
    this.userApiService.getPaiement().subscribe( 
      res => { this.card = res.data.card; this.payment = res.success},
      err => { this.payment = err.error.success } )
  }

  SubscribeUserDetailPayment(){
    this.userApiService.getUserDetailPaiement().subscribe( res => { 
       this.paymode = res.data.paymode; 
       this.userPaieFormu=res.data.contract.url_change_package} )
  }



  redirectFormu(){
    window.location.href= this.userPaieFormu; 
  }


  loaded : boolean = false;

}
